import { IBookedTrips, INextAndPreviousTrip } from "../../../Orchestrator/Types/Index";

export class QuickExchangeContext {

    public routeTo: string[] = [];
    public nextTo: string[] = [];

    public nearestRecord: IBookedTrips | any = null;
    public nextTrain: INextAndPreviousTrip  | any = null;
    public previousTrain: INextAndPreviousTrip  | any = null;
    constructor() {

    }
}